var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('div',{staticClass:"termBox"},[(_vm.selected === 7)?_c('CustomerNotice'):(_vm.selected === 6)?_c('UserAgreement'):_c('PrivatePolicy')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }